import React, { useState } from 'react';
import { bibleConfig, type BibleAsset } from '../data/bibleConfig';
import { safeUrl } from '../utils/safeUrl';
interface BibleCoverProps {
  asset: BibleAsset;
  lines: string[];
  note: string;
  eager?: boolean;
  className?: string;
}
export function BibleCover({
  asset,
  lines,
  note,
  eager = false,
  className = ''
}: BibleCoverProps) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const src = safeUrl(bibleConfig.images[asset]);
  const showImage = Boolean(src) && !failed;
  return <div className={`bible-tilt relative grid aspect-[4/5] place-items-center overflow-hidden rounded-lg border border-[#85704666] bg-[linear-gradient(145deg,#222127,#101013)] ${className}`} data-id="element-10" data-mp="fqw7umjv35yh">
      {!loaded || !showImage ? <p className="bible-serif px-6 py-6 text-center text-[clamp(21px,3vw,35px)] leading-[1.15] tracking-[0.02em] text-[#e9c769]" data-id="element-11" data-mp="tkvv1p1jhz6g">
          {lines.map((line, index) => <React.Fragment key={line} data-id="element-12" data-mp="1cujiu0f3env1" data-mpi={index}>
              {line}
              {index < lines.length - 1 ? <br data-id="element-13" data-mp="1cs6riwng315b" /> : null}
            </React.Fragment>)}
          <small className="mt-6 block text-[10px] font-normal leading-[1.5] tracking-[0.18em] text-[#beb9b0]" data-id="element-14" data-mp="18rd38263bkbw">
            {note}
          </small>
        </p> : null}

      {showImage ? <img src={src as string} alt={`${lines.join(' ')} — ${note}`} loading={eager ? 'eager' : 'lazy'} decoding="async" fetchPriority={eager ? 'high' : 'auto'} onLoad={() => setLoaded(true)} onError={() => setFailed(true)} className={`absolute inset-0 h-full w-full object-contain ${loaded ? '' : 'invisible'}`} data-id="element-15" data-mp="ywbcj1w62a77" /> : null}
    </div>;
}